module.exports = __webpack_public_path__ + "img/img_person.c8fa666d.png";